import React, { useMemo } from 'react';
import PopUp from 'app/Components/Shared/Popup/PopUp';
import FamilyPackageUsageDetails from './components/FamilyPackageUsageDetails/FamilyPackageUsageDetails';

const FamilyPackageUsageDetailsPopUp = ({showPopUp, onClose, packageUsages, collectiveUsages}) => {

  const isObjectNotEmpty = (obj) => obj && Object.keys(obj).length > 0;

  const isRenderConditionValid = useMemo(() => {
    return showPopUp && isObjectNotEmpty(packageUsages) && isObjectNotEmpty(collectiveUsages);
  }, [showPopUp, packageUsages, collectiveUsages]);

  return (
    isRenderConditionValid && (
      <div className='family-package-usage-details-pop-up'>
        <PopUp showPopUp={showPopUp} onClose={onClose}>
          <FamilyPackageUsageDetails
            title='כמה כל מנוי ניצל?'
            btnText='הבנתי, תודה'
            onClick={onClose}
            packageUsages={packageUsages}
            collectiveUsages={collectiveUsages}
          />
        </PopUp>
      </div>
    )
  );
};
export default FamilyPackageUsageDetailsPopUp;
